import { Injectable, signal } from '@angular/core';

/**
 * Zeigt an, ob die App-Shell (DefaultLayout mit Sidebar) gerade gemountet ist.
 *
 * Einziger Zweck: Das globale Umgebungs-Banner in der AppComponent soll sich
 * zurückziehen, sobald die Sidebar ihr eigenes Banner zeigt — sonst wären beide
 * gleichzeitig sichtbar.
 */
@Injectable({ providedIn: 'root' })
export class AppShellPresenceService {
  readonly mounted = signal(false);
}
